import { Action } from '../actions';
import { firstReferenceFromReferenceList, mergeObject } from '../helpers';

export function giveGetEligibilityReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'giveGetEligibility') {
        const { result, refList } = action.payload;
        return mergeObject<'giveGetEligibility'>(
          state,
          transformGiveGetEligibility(result),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    }
    default:
      return state;
  }
}

export function transformGiveGetEligibility(eligible: boolean) {
  return eligible;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/give-get/give-get.reducer.ts